import React from 'react'
import ProjectSession from "../../model2/project/project-session";

type Props = {
    className?  : string

    project?    : ProjectSession // | Project
    projectId?  : ID
    size?       : '13' | '14' | '16' |'17'
    colorize?   : boolean
    hint?       : boolean
}

// TUT fignya s size.... nado adekvatno podumat' sdelat'

export default function ProjectIconUI5(props:Props):any {

    const size = _.get(props, 'size', '13')


    // @ts-ignore
    let sessionProject : ProjectSession | null = props.projectId ? gd.session.projects.get(props.projectId) : props.project

    // patch to support templates
    // try check in tempaltes
    if (!sessionProject) {
        sessionProject = gd.session.templatesList.get(props.projectId)
    }

    // if no project found in session not in templates return false
    if (!sessionProject) {
        console.warn("ProjectIconUI5: no project in session")
        return false
    }

    const getColorClass = () => {

        // @ts-ignore
        return 'gd-c-font-'+sessionProject.color
    }

    const colorClass = props.colorize ? getColorClass() : false

    // @ts-ignore
    return <div className={Classes("gd-ui-project-icon", "ui5-ico-{0}".f(size), sessionProject.iconClass, colorClass, props.className)}/>
}
